document.addEventListener("DOMContentLoaded", function () {
 const blocks = document.querySelectorAll(".responsibility__block");

blocks.forEach((block) => {
  const link = block.querySelector(".responsibility__block-link");
  const text = block.querySelector(".responsibility__block-text");

  if (link && text) {
    link.addEventListener("click", () => {
      text.style.maxHeight = text.scrollHeight + "px";
      link.style.display = "none";
    });
  }
});
});